import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { MARKER_COLORS } from 'src/app/helpers/project-map-helper';
import { IPBoardPlacementTypeChoices } from 'src/app/model/product/ip-board/ip-board-placement-type';
import {
  SUB_PROJECT_TYPES,
  SubProject,
} from 'src/app/model/project/sub-project';
import { TourDetailSubProject } from '../../helper/model/tour-detail-sub-project';
import { TourDetailTourItem } from '../../helper/model/tour-detail-tour-item';

export class EmployeeTourMapHelper {
  private constructor() {}

  static getEmployeeTourMapMarkers(
    items: TourDetailTourItem[],
    withIndex = false
  ): EmployeeTourMapMarker[] {
    if (!CollectionHelper.isPopulated(items)) {
      return null;
    }
    const toReturn: EmployeeTourMapMarker[] = items.map((ti, i) => {
      const coordinates =
        ti.subProject != null
          ? ti.subProject.projectPlacement == null ||
            ti.subProject.projectPlacement.address == null
            ? null
            : ti.subProject.projectPlacement.address.coordinates
          : ti.immoTask != null && ti.immoTask.address != null
          ? ti.immoTask.address.coordinates
          : null;
      return coordinates == null
        ? null
        : {
            markerColor: this.getMarkerColor(
              ti,
              ti.subProject != null
                ? this.calculateSelectStonesMarker(ti.subProject)
                : false
            ),
            index: withIndex ? (i + 1).toString() : null,
            labelOrigin: withIndex ? new google.maps.Point(14, 16) : null,
            lat: coordinates.lat,
            lng: coordinates.lng,
          };
    });
    CollectionHelper.filterInPlace(toReturn, (e) => e != null);
    return toReturn;
  }

  private static calculateSelectStonesMarker(
    subProject: EmployeeTourMapSubProject
  ): boolean {
    // unfortunately, CollectionHelper.isPopulated does not appear to work with types of kind T[] | U[]
    return (
      subProject.project != null &&
      subProject.project.products != null &&
      subProject.project.products.length > 0 &&
      subProject.project.products.some((p: any) => {
        return (
          p.boardPart != null &&
          p.boardPart.placementType != null &&
          p.boardPart.placementType.ordinal ===
            IPBoardPlacementTypeChoices.ON_STONES.ordinal
        );
      })
    );
  }

  private static getMarkerColor(
    item: TourDetailTourItem,
    selectStonesMarker: boolean
  ): string {
    if (item.subProject != null) {
      if (
        item.tourItemBackgroundClass === 'executed' ||
        item.tourItemBackgroundClass === 'not-executed'
      )
        return MARKER_COLORS.GRAY_MARKER;

      switch (item.subProject.type) {
        case SUB_PROJECT_TYPES.BASE_PROJECT:
          return selectStonesMarker
            ? MARKER_COLORS.GREEN_MARKER_STONES
            : MARKER_COLORS.GREEN_MARKER;
        case SUB_PROJECT_TYPES.ADJUSTMENT:
          return selectStonesMarker
            ? MARKER_COLORS.BLUE_MARKER_STONES
            : MARKER_COLORS.BLUE_MARKER;
        case SUB_PROJECT_TYPES.SOLDRENTED:
          return selectStonesMarker
            ? MARKER_COLORS.YELLOW_MARKER_STONES
            : MARKER_COLORS.YELLOW_MARKER;
        case SUB_PROJECT_TYPES.REPO:
          return selectStonesMarker
            ? MARKER_COLORS.RED_MARKER_STONES
            : MARKER_COLORS.RED_MARKER;
        default:
          throw new Error(
            `subproject type not recognized: ${item.subProject.type}`
          );
      }
    } else if (item.immoTask != null) {
      return MARKER_COLORS.PURPLE_MARKER;
    } else {
      return MARKER_COLORS.GRAY_MARKER;
    }
  }
}

export interface EmployeeTourMapMarker {
  markerColor: string;
  index: string;
  labelOrigin: google.maps.Point;
  lat: number;
  lng: number;
}

type EmployeeTourMapSubProject = TourDetailSubProject | SubProject;
